import React from 'react';
import { Header } from '../components/ui/header-2';
import { Footer } from '../components/landing/Footer';
import { Pricing as PricingComponent } from '../components/landing/Pricing';
import { Check, Info } from 'lucide-react';

export const PricingPage = () => {
    return (
        <>
            <Header />
            <main style={{ minHeight: '100vh', background: 'var(--bg-primary)', overflowX: 'hidden' }}>
                {/* Hero */}
                <section style={{ padding: '120px 24px 80px', textAlign: 'center', position: 'relative' }}>
                    <div className="animate-float" style={{ position: 'absolute', top: '10%', left: '50%', transform: 'translateX(-50%)', width: '500px', height: '500px', background: 'var(--accent-primary)', filter: 'blur(200px)', opacity: 0.1, borderRadius: '50%', zIndex: 0 }}></div>
                    <div className="container" style={{ position: 'relative', zIndex: 1, maxWidth: '800px' }}>
                        <div style={{ display: 'inline-block', padding: '6px 16px', background: 'rgba(255,255,255,0.05)', borderRadius: '24px', border: '1px solid var(--border-subtle)', marginBottom: '32px', color: 'var(--text-secondary)', fontSize: '0.875rem', fontWeight: 600 }}>
                            💳 Simple Economics
                        </div>
                        <h1 style={{ fontSize: 'clamp(3rem, 5vw, 4.5rem)', marginBottom: '24px', letterSpacing: '-0.02em', lineHeight: 1.1 }}>
                            We Win When <span className="text-gradient-accent">You Win.</span>
                        </h1>
                        <p style={{ fontSize: '1.25rem', color: 'var(--text-secondary)', marginBottom: '48px', lineHeight: 1.6 }}>
                            We don't believe in punishing businesses before they grow. That's why building your tables and adding staff is completely free.
                        </p>
                    </div>
                </section>

                <PricingComponent />

                {/* Explanation */}
                <section style={{ padding: '80px 24px', background: 'var(--bg-secondary)', borderTop: '1px solid var(--border-subtle)', borderBottom: '1px solid var(--border-subtle)' }}>
                    <div className="container" style={{ maxWidth: '800px', textAlign: 'center' }}>
                        <div style={{ display: 'inline-block', padding: '16px', borderRadius: '50%', background: 'rgba(59, 130, 246, 0.1)', marginBottom: '32px' }}>
                            <Info size={40} color="var(--accent-primary)" />
                        </div>
                        <h2 style={{ fontSize: '2.5rem', marginBottom: '24px', fontWeight: 800 }}>How the System Works</h2>
                        <ul style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '24px', fontSize: '1.125rem', color: 'var(--text-secondary)', lineHeight: 1.6 }}>
                            <li style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                                <div style={{ background: 'var(--bg-tertiary)', padding: '8px', borderRadius: '50%', marginTop: '4px' }}>
                                    <Check size={20} color="var(--accent-primary)" />
                                </div>
                                <div>
                                    <strong style={{ color: 'var(--text-primary)' }}>Free Account Creation:</strong> Register your business, upload your entire menu, and create hundreds of tables layout QR codes without paying a single cent.
                                </div>
                            </li>
                            <li style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                                <div style={{ background: 'var(--bg-tertiary)', padding: '8px', borderRadius: '50%', marginTop: '4px' }}>
                                    <Check size={20} color="var(--accent-primary)" />
                                </div>
                                <div>
                                    <strong style={{ color: 'var(--text-primary)' }}>Free Staff Management:</strong> Unlimited staff members can be added. They can use the digital notification system to respond to guest calls instantly for free.
                                </div>
                            </li>
                            <li style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                                <div style={{ background: 'var(--bg-tertiary)', padding: '8px', borderRadius: '50%', marginTop: '4px' }}>
                                    <Check size={20} color="var(--accent-primary)" />
                                </div>
                                <div>
                                    <strong style={{ color: 'var(--text-primary)' }}>The Ordabell Transaction Fee:</strong> If, and only if, a customer decides to pay their food bill digitally through the printed QR code using their card (via global payment providers), we take a small transparent markup fee on that single transaction to cover server costs. If they pay in cash at the counter, you owe us nothing.
                                </div>
                            </li>
                        </ul>
                    </div>
                </section>

                <section style={{ padding: '120px 24px', textAlign: 'center' }}>
                    <div className="container" style={{ maxWidth: '600px' }}>
                        <h2 style={{ fontSize: '2.5rem', marginBottom: '24px', fontWeight: 800 }}>Zero Risk. Only Reward.</h2>
                        <button className="btn btn-primary" style={{ padding: '16px 36px', fontSize: '1.125rem' }}>Create Free Account</button>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};
